import React, { useState, Fragment } from 'react'
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { withStyles, Theme } from '@material-ui/core/styles';

interface FieldValues {
  title: any
}

const TooltipInfo: React.FC<FieldValues> = ({ title }) => {
  const LightTooltip = withStyles((theme: Theme) => ({
    arrow: {
      fontSize: 24,
      color: 'white',
      '&::before': {
        border: '1px solid #ccc',
        backgroundColor: 'white', 
      }
    },
    tooltip: {
      fontFamily: 'ToyotaType, sans-serif',
      padding: '8px 12px',
      marginBottom: '20px',
      border: 'solid 1px #ccc',
      backgroundColor: theme.palette.common.white,
      color: '#1a1a1a',
      fontSize: 14,
      fontWeight: 400,
      '& strong:first-child:last-child': {
        fontSize: 14,
        color: '#1a1a1a'
      },
      '& p': {
        fontSize: 12,
        color: '#808080'
      }, 
      '& p + p': {
        marginTop: '1em'
      }
    },
  }))(Tooltip);
  const [open, setOpen] = useState(false);
  const handleClickAway = () => {
    setOpen(false);
  };
  const handleIconClick = (e: any) => {
    e.stopPropagation();
    setOpen(!open);
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <LightTooltip arrow 
       placement="top"
        PopperProps={{
          disablePortal: true,
        }}
        title={title} 
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <button className="i-tooltip" 
          aria-label="More info"
          onClick={handleIconClick}
        ></button>
      </LightTooltip>
    </ClickAwayListener>
  )};

export default TooltipInfo